'use client'
import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useAppSelector } from '@/store/hooks'
import { ROLES } from '@/shared/constants'
import CoexEmbeddedSignupButton from '@/components/global/whatsapp/CoexEmbeddedSignupButton'
import MonthlyCostCalculator from './MonthlyCostCalculator'
import OfficialApiHelp from './OfficialApiHelp'

export default function OfficialApiActivationDialog({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) {
  const { user } = useAppSelector((state) => state.auth)
  if (user?.role?.id !== ROLES.COMPANY_ADMIN) return null
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      aria-labelledby="official-api-activation-title"
    >
      <DialogTitle
        id="official-api-activation-title"
        sx={{ position: 'relative', pr: 5 }}
      >
        Ativar API oficial do WhatsApp
        <IconButton
          onClick={onClose}
          aria-label="Fechar"
          sx={{ position: 'absolute', right: 0, top: -8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Alert severity="info">
            Após ativar, campanhas e listas usarão{' '}
            <strong>somente a API oficial</strong>, com templates aprovados pela
            Meta.
          </Alert>
          {open && <MonthlyCostCalculator compact />}
          {open && <OfficialApiHelp compact />}
        </Stack>
      </DialogContent>
      <DialogActions>
        {open && <CoexEmbeddedSignupButton label="Ativar na Meta" />}
      </DialogActions>
    </Dialog>
  )
}
